import OutOfChargeRenderer from './OutOfChargeRenderer';

export default OutOfChargeRenderer;
